var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconCancel(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 22,
    viewBox: "0 0 21 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.735184 1.16219C1.39902 0.498347 2.47532 0.498347 3.13916 1.16219L10.6184 8.64144L18.0977 1.16219C18.7615 0.498347 19.8378 0.498347 20.5016 1.16219C21.1655 1.82602 21.1655 2.90232 20.5016 3.56616L13.0224 11.0454L20.5016 18.5247C21.1655 19.1885 21.1655 20.2648 20.5016 20.9286C19.8378 21.5925 18.7615 21.5925 18.0977 20.9286L10.6184 13.4494L3.13916 20.9286C2.47532 21.5925 1.39902 21.5925 0.735184 20.9286C0.071345 20.2648 0.071345 19.1885 0.735184 18.5247L8.21443 11.0454L0.735184 3.56616C0.071345 2.90232 0.071345 1.82602 0.735184 1.16219Z",
    fill: "#001A27"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCancel);
export default __webpack_public_path__ + "static/media/icon_cancel.a11bd7b460202aefb59a7912d23742f0.svg";
export { ForwardRef as ReactComponent };